export class EmpresaPrestacaoServico {
  nome: string;
  ddd: string;
  telefone: string;
  tipoTransporte: number;
  tipoTransporteOutro: string;
}
